export default {
  // Hero section
  'hero.title': 'Alat Timer Online Profesional',
  'hero.subtitle': 'Pilih alat pengatur waktu yang sempurna untuk kebutuhan Anda',

  // Tool cards
  'timer.title': 'Timer',
  'timer.description': 'Timer hitung mundur untuk pekerjaan, belajar, dan kehidupan',
  'timer.longDescription': 'Timer hitung mundur untuk produktivitas, memasak, dan manajemen waktu',
  'timer.button': 'Mulai Timer',

  'stopwatch.title': 'Stopwatch',
  'stopwatch.description': 'Alat pengatur waktu presisi tinggi',
  'stopwatch.longDescription': 'Stopwatch presisi tinggi untuk olahraga, pelatihan, dan pengaturan waktu yang tepat',
  'stopwatch.button': 'Mulai Stopwatch',

  'worldclock.title': 'Jam Dunia',
  'worldclock.description': 'Lihat zona waktu di seluruh dunia',
  'worldclock.longDescription': 'Tampilan waktu real-time kota-kota besar global dengan perhitungan zona waktu yang cerdas',
  'worldclock.button': 'Lihat Jam Dunia',

  // Features section
  'features.title': 'Mengapa Memilih timer.today?',
  'features.reliable.title': 'Andal & Akurat',
  'features.reliable.desc': 'Pengaturan waktu presisi milidetik dengan keandalan berbasis browser',
  'features.crossPlatform.title': 'Lintas Platform',
  'features.crossPlatform.desc': 'Berfungsi dengan mulus di desktop, tablet, dan perangkat mobile',
  'features.smartNotifications.title': 'Notifikasi Cerdas',
  'features.smartNotifications.desc': 'Peringatan suara dan notifikasi desktop saat waktu habis',
  'features.easyToUse.title': 'Mudah Digunakan',
  'features.easyToUse.desc': 'Antarmuka bersih dengan kontrol intuitif untuk semua pengguna',

  // Keywords section
  'keywords.timer': 'timer hitung mundur pomodoro fokus kerja istirahat',
  'keywords.chinese': '计时器 倒计时 番茄钟 专注 休息',
  'keywords.japanese': 'タイマー カウントダウン ポモドーロ 集中 休憩',
  'keywords.spanish': 'temporizador cuenta regresiva pomodoro concentración',
  'keywords.german': 'Timer Countdown Pomodoro Konzentration Pause',
  'keywords.french': 'minuteur compte à rebours pomodoro concentration',
  'keywords.russian': 'таймер обратный отсчет помодоро концентрация',
};
